import { handleMessageChange } from "./handleMessageChange";
export function handleUpdateCardComponent(
  selectedNode,
  cardIndex,
  componentIndex,
  newData,
  nodes,
  setNodes,
  setCards,
) {
  const updatedCards = [...selectedNode.data.cards];
  const updatedCard = { ...updatedCards[cardIndex] };
  const updatedComponents = [...updatedCard.components];

  updatedComponents[componentIndex] = {
    ...updatedComponents[componentIndex],
    ...newData,
  };

  updatedCard.components = updatedComponents;
  updatedCards[cardIndex] = updatedCard;
  handleMessageChange("cards", updatedCards, nodes, setNodes, selectedNode);
  setCards(updatedCards);
}
